import { useMemo } from "react";
import { useConfig } from "render/context/ConfigContext";
import {
  type AuthMethod,
  createPatientDeviceURL,
  createSessionToken,
} from "../token";

export function useQRCodeURL({
  authMethod,
  sessionId,
  siteId,
}: {
  authMethod: AuthMethod;
  sessionId: string | undefined;
  siteId: string | undefined;
}) {
  const config = useConfig();

  const token = useMemo(() => {
    if (!sessionId || !siteId) {
      return;
    }

    return createSessionToken(sessionId, siteId);
  }, [sessionId, siteId]);

  const url = useMemo(() => {
    if (!token) {
      return;
    }
    const url = config.apiBaseUrl.includes("preprod")
      ? "https://patient.preprod.cur8.co/"
      : config.appConfig.patientAppBaseUrl;
    return createPatientDeviceURL(token, url, authMethod);
  }, [token, config, authMethod]);

  return url;
}
